import { ensureUnit } from '../ensure-unit';
import type { BorderControlValue } from './types';

/**
 * Convert BorderControl value to CSS border properties
 *
 * @param {BorderControlValue | object} borderValue - Border value from BorderControl
 * @returns {object} CSS border properties
 */
export function convertBorderToCSS(
	borderValue: BorderControlValue | object,
): object {
	if ( ! borderValue || typeof borderValue !== 'object' ) {
		return {};
	}

	const border = borderValue as BorderControlValue;
	const cssProps: { [ key: string ]: string } = {};

	if ( border.color ) {
		cssProps.borderColor = border.color;
	}

	if ( border.style ) {
		cssProps.borderStyle = border.style;
	}

	if ( border.width ) {
		cssProps.borderWidth = ensureUnit( border.width );
	}

	return cssProps;
}
